<template>
  <div v-if="contact" class="flex flex-between flex-vertical-center">
    <div>
      <p class="contact--types">{{ contactTypeText }}</p>
      <h3 class="contact--name" @click="openContactModal">{{ contact.full_name }}</h3>

      <p v-if="contact.phone_1" class="contact--info">
        <sensitive-data-wrapper>
          <template>{{ $utils.formatNumber(contact.phone_1) }}</template>
        </sensitive-data-wrapper>
      </p>
      <p v-if="contact.email_address" class="contact--info">
        <sensitive-data-wrapper>
          <template>{{ contact.email_address }}</template>
        </sensitive-data-wrapper>
      </p>
    </div>

    <comm-buttons
      :contact="contact"
      :record="record"
      include-button-text
    ></comm-buttons>
  </div>
  <p v-else class="empty_message">No primary contact for this lead</p>
</template>

<script>
import CommButtons from "../../../components/comms/CommButtons";
import {ENUMS} from "../../../services/enums";
import router from "../../../router";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "InboxContentContactBox",
  components: {SensitiveDataWrapper, CommButtons},
  props: {
    type: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isNewLead() {
      return this.type === ENUMS.InboxTypeEnum.NewLead.value;
    },
    isInboundComm() {
      return this.type === ENUMS.InboxTypeEnum.InboundComm.value;
    },
    record() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/record"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/record"]
    },
    contact() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/contact"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/contact"];
    },
    contactTypes() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/contactTypes"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/contactTypes"];
    },
    contactTypeText() {
      let text = "";

      if (this.contactTypes) {
        this.contactTypes.forEach(type => {
          let allContactTypes = this.$store.state.market.contactTypes;
          const contactType = allContactTypes.find(contactType => contactType.id === type.contact_type_id);

          if (contactType) text += contactType.name + ", ";
        });

        text = text.trim().slice(0, -1);
      }

      return text;
    }
  },
  methods: {
    openContactModal() {
      router.replace({query: {contact: this.contact.id}});
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.contact {

  &--types {
    margin-bottom: 6px;
    color: $text-muted;
    font-size: 0.75rem;
  }

  &--name {
    color: $link;
    font-size: 1.25rem;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--info {
    margin-top: 6px;
    font-size: 0.875rem;
  }
}

.empty_message {
  padding: 1rem 0;
  color: $text-light;
  text-align: center;
  font-style: italic;
}
</style>
